import React, { useEffect, useState } from 'react';
import './App.css';


import Header from './Header';
import Footer from './Footer';



function Askmeanything() {
const OPENROUTER_API_KEY = "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"
const [question, setQuestion] = useState('');
const [answer, setAnswer] = useState('');
const [loading, setLoading] = useState(false);
const [isDarkMode, setIsDarkMode] = useState(false);

const onChange = (e) => {
  setQuestion(e.target.value);
};

const onClick = async () => {
  if (!question) {
    alert("Please enter a question.");
    return;
  }

  setLoading(true);
  const response = await fetch("https://openrouter.ai/api/v1/chat/completions", {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${OPENROUTER_API_KEY}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      "model": "meta-llama/llama-3.3-70b-instruct:free",
      "models": ["meta-llama/llama-3.3-8b-instruct:free", "deepseek/deepseek-r1-0528:free", "mistralai/mistral-small-3.2-24b-instruct:free, openai/gpt-4o-mini, x-ai/grok-4.1-fast:free"],
      "messages": [
        { "role": "system", "content": "I want you to give the answer to the question based on the user input." },
        { "role": "user", "content": question },
      ],
    })
  });

  const data = await response.json();
  const aiResponse = data.choices[0].message.content;
  setAnswer(aiResponse);
  setLoading(false);
};

const toggleDarkMode = () => {
  setIsDarkMode(!isDarkMode);
};

return (
  <div className={`page-container ${isDarkMode ? 'dark-mode' : ''}`}>
    <div className="content-wrap">
      <Header darkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <h1>Homework Solver</h1>
      <p>Enter a question</p>
      <textarea onChange={onChange} value={question} rows={4} cols={50} placeholder={`Which famous scientist discovered the laws of motion and gravity? \nA) Isaac Newton \nB) Albert Einstein \nC) Galileo Galilei \nD) Stephen Hawking`} maxLength={1500}
required/>
      <button onClick={onClick}>Submit</button>
      <div className="container">
        {loading ? (
          <p className="answer">StudyPal is thinking ... </p>
        ) : (
          <p className="answer">{answer}</p>
        )}
      </div>
      <div className="terms-spacer"></div>
    </div>
    <Footer darkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
  </div>
);
}

export default Askmeanything;
